<template>
  <div class="Main">
    <van-nav-bar
        fixed
        :border="false"
        :title="$t('postRecord[11]')"
        left-arrow
        @click-left="$router.go(-1)"
    />
    <div class="PageBox">
      <div class="ScrollBox">
		  <div class="welcome-container">
		    <div class="welcome-header">
		      <van-icon name="certificate" color="#37774C" size="24px" />
		      <h2 style="color: #37774C">{{ $t('informationHub') }}</h2>
		      <van-icon name="medal" color="#37774C" size="24px" />
		    </div>
		    
		    <div class="welcome-content">
		      <p class="highlight-box">
		        {{$t('charitables[0]')}}
		      </p>
		  
		    </div>
		  </div>
		<van-image :src="item.url" is-link v-for="item in InitData.information" :key="item.id" @click="openShow(item)"></van-image>
        <van-empty :description="$t('help[1]')" v-if="!InitData.information.length" />
      </div>
    </div>
    <van-popup v-model="showCon" position="bottom" closeable close-on-popstate  style="width: 100%;height: 100%;background-color:rgb(255, 255, 255);color:#fff;">
      <div class="ScrollBox" style="padding: 16px 20px;">
        <h3 style="text-align: center;margin-bottom: 20px;color:#333">{{infoData.title}}</h3>
        <div class="Content" style="text-align: justify;color:#333" v-html="infoData.content"></div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'Help',
  components: {
  },
  props: [],
  data() {
    return {
      showCon: false,
      infoData: '',
    }
  },
  computed: {

  },
  watch: {

  },
  created() {

  },
  mounted() {

  },
  activated() {

  },
  destroyed() {

  },
  methods: {
    openShow(data) {
		console.log(data)
		if(data.jump == ""){
			this.showCon = true
			this.infoData = data
		}else{
			window.location.href = data.jump;
		}
		
      
    }
  }
}
</script>
<style scoped>
.Content ::v-deep img{
  max-width: 100%;
}
::v-deep .van-nav-bar__content {
  background: linear-gradient(to right,$theme-shallow-color, $theme-color);
  color: #fff;
}
::v-deep .van-nav-bar__title {
  color: #fff;
}
::v-deep .van-nav-bar .van-icon {
  color: #fff !important;
}


.welcome-container {
  background: #f0f9f1;
  border-radius: 15px;
  padding: 20px;
  margin: 15px;
  box-shadow: 0 4px 12px rgba(55, 119, 76, 0.1);
}

.welcome-header {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}

.highlight-box {
  background: linear-gradient(145deg, #e6f4ea, #ffffff);
  border-left: 4px solid #37774C;
  padding: 15px;
  color: #333;
  font-size: 16px;
  line-height: 1.6;
}

.info-card {
  background: #ffffff;
  border-radius: 10px;
  padding: 15px;
  margin: 12px 0;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 2px 6px rgba(55, 119, 76, 0.1);
}

.whatsapp-bg {
  background: #25D366;
  color: white;
}

.media-reviews {
  margin: 20px 0;
  text-align: center;
  font-style: italic;
  color: #37774C;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

/* 响应式设计 */
@media (max-width: 480px) {
  .welcome-container {
    padding: 15px;
    margin: 10px;
  }
  
  .highlight-box {
    font-size: 14px;
  }
}
</style>